import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';

import { InvestService } from '@services/invest.service';
import { Invest } from '@classes/invest/invest';
import { InvestProject } from '@classes/invest/invest-project';
import { User } from '@classes/licence/user';

@Component({
    selector: 'app-invest-select',
    templateUrl: './invest-select.component.html',
    styleUrls: ['./invest-select.component.scss']
})
export class InvestSelectComponent implements OnInit {
    @Input() selectedInvest: Invest;
    @Output() projectsChanged = new EventEmitter<InvestProject[]>();

    // invests: Invest[];
    investsByUsers: User[];
    selectForm: FormGroup;
    isLoading: boolean;

    constructor(
        private investSrv: InvestService,
        private fb: FormBuilder
    ) { }

    ngOnInit() {
        this.initSubscriptions();
    }

    getProjects(): void {
        this.investSrv.getProjects(this.selectForm.value.invest, this.selectedInvest.simulation.provider)
        .subscribe(projectsFromSrv => {
            this.projectsChanged.emit([...projectsFromSrv]);
        });
    }

    private initSubscriptions(): void {
        this.investSrv.getListByUser()
        .subscribe(investsFromSrv => {
            this.investsByUsers = investsFromSrv;
            this.initForm();
        });
    }

    private initForm(): void {
        this.selectForm = this.fb.group({
            invest: [this.selectedInvest.code, Validators.required]
        });
    }
}
